
import Landing from '@/components/Landing.vue';
import { MetaSourceProxy, useMeta } from 'vue-meta';
import { computed, Ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import Outcome from '@/components/Outcome.vue';

export default {
  name: 'Home',
  components: {
    Outcome,
    Landing,
  },
  setup(): { meta: MetaSourceProxy; sessionFinished: Ref<boolean> } {
    const { t } = useI18n();
    const store = useStore();
    const sessionFinished: Ref<boolean> = computed(() => store.getters['videos/isSessionFinished']);

    const metaInfoTitle = computed(() => t('HOME META'));
    const { meta } = useMeta({
      title: metaInfoTitle.value,
    });

    return {
      meta,
      sessionFinished,
    };
  },
};
